import * as React from 'react';

const styles = require('./title.css');

interface IProps {
  tag?: string;
}

export class Title extends React.PureComponent<IProps, object> {
  public render() {
    return <h2 className={styles['title']}>{this.props.children}</h2>;
  }
}
